import { render } from "./ApprovalDetails.vue?vue&type=template&id=53db0299&scoped=true"
import script from "./ApprovalDetails.vue?vue&type=script&lang=js"
export * from "./ApprovalDetails.vue?vue&type=script&lang=js"

import "./ApprovalDetails.vue?vue&type=style&index=0&id=53db0299&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53db0299"]])

export default __exports__